import { DotLoading } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import PsContext from "../../context";
import { getTodayDate } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const FeeCount = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    let m = context.getStorageByDate("dahboard_fee_count");
    if (m) setDataList(m);
    getReport();
  }, []);

  const getReport = () => {
    setLoader(true);
    axios.get(ServiceUrl.MOB.DASHBOARD_FEE_COLLECTION_COUNT).then((res) => {
      if (res["data"].status == "1") {
        context.setStorage("dahboard_fee_count", res.data.data, getTodayDate());
        setDataList(res["data"].data);
      }
      setLoader(false);
    });
  };

  const field = (fieldName) => dataList?.[fieldName] || (loader ? "" : "0");

  return (
    <>
      <div class="flash-sale-wrapper p-2">
        <Row className="g-2">
          <Col md={6} sm={6} xs={6}>
            <div className="card flash-sale-card bg-gradiant bg-border">
              <div className="card-body">
                <span className="product-title">Total Students</span>
                <p className="sale-price mt-2 fw-bold">
                  {field("total_students")}
                </p>
                {loader && dataList.length < 1 && <DotLoading />}
              </div>
            </div>
          </Col>
          <Col md={6} sm={6} xs={6}>
            <div className="card flash-sale-card bg-gradiant bg-border">
              <div className="card-body">
                <span className="product-title">Total Staffs</span>
                <p className="sale-price mt-2 fw-bold">
                  {field("total_staffs")}
                </p>
                {loader && dataList.length < 1 && <DotLoading />}
              </div>
            </div>
          </Col>
          <Col md={6} sm={6} xs={6}>
            <div className="card flash-sale-card bg-gradiant bg-border">
              <div className="card-body">
                <span className="product-title">Today Collection</span>
                <p className="sale-price mt-2 fw-bold">
                  {field("today_fee_collection")}
                </p>
                {loader && dataList.length < 1 && <DotLoading />}
              </div>
            </div>
          </Col>
          <Col md={6} sm={6} xs={6}>
            <div className="card flash-sale-card bg-gradiant bg-border">
              <div className="card-body">
                <span className="product-title">This Month Collection</span>
                <p className="sale-price mt-2 fw-bold">
                  {field("month_fee_collection")}
                </p>
                {loader && dataList.length < 1 && <DotLoading />}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default FeeCount;
